import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import { Layout } from "./components/layout/Layout";
import { ConfigProvider } from "antd";
import { createContext, useEffect, useState } from "react";
import { widgetActions } from "./redux store/widgetSlice";
import { useDispatch, useSelector } from "react-redux";
import tokenService from "./services/token";
import settingsService from "./services/settings";
import constantsService from "./services/text-files";
import textFilesService from "./services/text-files";

export const NavigationContext = createContext();

function App() {
  const [settings, setSettings] = useState({});
  const [headerScript, setHeaderScript] = useState("");
  const [footerScript, setFooterScript] = useState("");
  const [isBackNavigation, setIsBackNavigation] = useState(false);
  const [doctorsRefresh, setDoctorsRefresh] = useState(false);
  const [blogsRefresh, setBlogsRefresh] = useState(false);
  const [constants, setConstants] = useState({});
  console.log("back navigation value", isBackNavigation);
  const { homeApis } = useSelector((state) => state.widget); // Access widget data
  console.log("constants are", constants);
  

  const getSettings = async () => {
    const data = await settingsService.getAll();

    if (data?.data) {
      setSettings(data?.data[0]);
    }
  };

  useEffect(() => {
    console.log("home apis rrr", homeApis);
    setHeaderScript(homeApis?.adminSettings?.[0]?.headerScript || "");
    setFooterScript(homeApis?.adminSettings?.[0]?.bodyScript || "");
  }, [homeApis]);

  console.log("settings app", settings);

  // useEffect(() => {
  //   if (headerScript) {
  //     const script = document.createElement("script");
  //     script.innerHTML = headerScript;
  //     document.head.appendChild(script);
  //   }
  // }, [headerScript]);

  useEffect(() => {
    if (!headerScript) return;

    // Use a temporary container to parse all tags (including <noscript>)
    const container = document.createElement("div");
    container.innerHTML = headerScript;

    const appendedScripts = [];
    const appendedNoscripts = [];

    // Process script tags
    const scriptElements = container.querySelectorAll("script");
    scriptElements.forEach((scriptElement) => {
      const script = document.createElement("script");
      script.type = scriptElement.getAttribute("type") || "text/javascript";

      if (scriptElement.src) {
        script.src = scriptElement.src;
        script.async = true;
      } else {
        script.textContent = scriptElement.textContent;
      }

      if (scriptElement.hasAttribute("defer")) {
        script.defer = true;
      }

      if (scriptElement.hasAttribute("referrerpolicy")) {
        script.referrerPolicy = scriptElement.getAttribute("referrerpolicy");
      }

      document.head.appendChild(script);
      appendedScripts.push(script);
    });

    // Process noscript tags (preserved now)
    // const noscriptElements = container.querySelectorAll("noscript");
    // noscriptElements.forEach((noscriptEl) => {
    //   const wrapper = document.createElement("div");
    //   wrapper.innerHTML = noscriptEl.innerHTML;
    //   //wrapper.style.display = "none"; // optional: visually hidden
    //   document.body.appendChild(wrapper);
    //   appendedNoscripts.push(wrapper);
    // });

    // Cleanup
    return () => {
      appendedScripts.forEach((script) => {
        document.head.removeChild(script);
      });
      // appendedNoscripts.forEach((el) => {
      //   document.body.removeChild(el);
      // });
    };
  }, [headerScript]);

  useEffect(() => {
    if (!footerScript) return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(footerScript, "text/html");

    // Process <script> tags
    const scriptElements = doc.querySelectorAll("script");
    const appendedScripts = [];

    scriptElements.forEach((scriptElement) => {
      const script = document.createElement("script");
      script.type = scriptElement.getAttribute("type") || "text/javascript";

      if (scriptElement.src) {
        script.src = scriptElement.src;
        script.async = true;
      } else {
        script.textContent = scriptElement.textContent;
      }

      if (scriptElement.hasAttribute("defer")) {
        script.defer = true;
      }

      if (scriptElement.hasAttribute("referrerpolicy")) {
        script.referrerPolicy = scriptElement.getAttribute("referrerpolicy");
      }

      document.body.appendChild(script);
      appendedScripts.push(script);
    });

    // Process <noscript> (for preserving in DOM, optional)
    // const noscriptElements = doc.querySelectorAll("noscript");
    // const appendedNoscripts = [];

    // noscriptElements.forEach((noscriptEl) => {
    //   const wrapper = document.createElement("div");
    //   wrapper.innerHTML = noscriptEl.innerHTML; // not actual <noscript>, just a div
    //   wrapper.style.display = "none"; // hide it, just in case
    //   document.body.appendChild(wrapper);
    //   appendedNoscripts.push(wrapper);
    // });

    return () => {
      appendedScripts.forEach((script) => {
        document.head.removeChild(script);
      });
      // appendedNoscripts.forEach((el) => {
      //   document.body.removeChild(el);
      // });
    };
  }, [footerScript]);

  // useEffect(() => {
  //   if (footerScript) {
  //     const script = document.createElement("script");
  //     script.innerHTML = footerScript;
  //     document.body.appendChild(script);
  //   }
  // }, [footerScript]);

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fileUrl = constants?.widgetTxt;
        // "https://sabine-test.s3.ap-south-1.amazonaws.com/home-file.txt";

        const textResponse = await fetch(fileUrl, {
          method: "GET",
          headers: {
            "Cache-Control": "no-cache",
          },
          cache: "no-cache",
        });
        console.log("text response is", textResponse);

        const textData = await textResponse.text();
        console.log("text data is", textData);
        const parsedData = JSON.parse(textData);
        console.log("parsed data", parsedData);
        const widgets = parsedData?.widgets;
        console.log("widgets in app.js", widgets);
        dispatch(widgetActions.setWidgets({ widgets: parsedData?.widgets }));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    if (constants?.widgetTxt) {
      fetchData();
    }
  }, [constants]);

  const getTextFiles = async () => {
    try {
      const data = await textFilesService.getAll();
      console.log("fetched data", data);
      if (data) {
        setConstants(data?.data);
      } else {
      }
    } catch (err) {}
  };

  useEffect(() => {
    getTextFiles();
  }, []);

  useEffect(() => {
    const fetchHomeApi = async () => {
      try {
        const fileUrl = constants?.generalTxt;
        // "https://sabine-test.s3.ap-south-1.amazonaws.com/home-file.txt";

        const textResponse = await fetch(fileUrl, {
          method: "GET",
          headers: {
            "Cache-Control": "no-cache",
          },
          cache: "no-cache",
        });
        console.log("text response is", textResponse);

        const textData = await textResponse.text();
        console.log("text data is", textData);
        const parsedData = JSON.parse(textData);
        console.log("parsed data home file", parsedData);
        const homeApis = parsedData;
        console.log("data in app.js", homeApis);
        dispatch(widgetActions.setApis({ homeApis: parsedData }));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    if (constants?.generalTxt) {
      fetchHomeApi();
    }
  }, [constants]);

  const getAPItoken = async () => {
    const apiLoginData = await tokenService.getAPIAccessToken();
    console.log("api login data", apiLoginData);
    // window.localStorage.clear();
    window.localStorage.removeItem("accesstoken");
    if (apiLoginData?.status == "success") {
      const accessToken = apiLoginData.responseArray.access_token;
      window.localStorage.setItem("accesstoken", accessToken);
      console.log("token in appjs", accessToken);
    }
  };

  useEffect(() => {
    getAPItoken();
  }, []);

  if (process.env.NODE_ENV === "production") {
    console.log = () => {};
    console.warn = () => {};
    console.error = () => {};
  }


  return (
    <ErrorBoundary>
      <Router>
        <ConfigProvider
          theme={{
            token: {
              fontFamily: "Montserrat, sans-serif", // Change to your desired font family
            },
          }}
        >
          <NavigationContext.Provider
            value={{
              isBackNavigation,
              setIsBackNavigation,
              doctorsRefresh,
              setDoctorsRefresh,
              blogsRefresh,
              setBlogsRefresh
            }}
          >
            <Layout>
              <AppRoutes
                isBackNavigation={isBackNavigation}
                setIsBackNavigation={setIsBackNavigation}
              />
            </Layout>
          </NavigationContext.Provider>
        </ConfigProvider>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
